import { useEffect } from 'react';
import { useBetSlip } from './betSlipContext';

/*
  Placement confirmation, rendered once in AppShell so it is seen wherever the
  slip was — rail or sheet — and on whichever page the customer is on. The
  inline banner at the top of BetsPage was invisible from the sheet on a phone,
  which is most of where the slip now lives.
*/
export function BetPlacedToast() {
  const { successMsg, dismissSuccess } = useBetSlip();
  useEffect(() => {
    if (!successMsg) return;
    const t = window.setTimeout(dismissSuccess, 6000);
    return () => window.clearTimeout(t);
  }, [successMsg, dismissSuccess]);
  if (!successMsg) return null;
  return (
    <div role="status" className="fixed left-1/2 -translate-x-1/2 bottom-[76px] xl:bottom-6 z-40 max-w-[calc(100vw-32px)] rounded-xl border border-brand-green/30 bg-[#0b2a18]/95 backdrop-blur-md px-4 py-3 text-sm text-brand-green shadow-glow flex items-center gap-3">
      <span>{successMsg}</span>
      <button type="button" onClick={dismissSuccess} className="text-brand-green/60 hover:text-brand-green" aria-label="Dismiss">✕</button>
    </div>
  );
}
